import { Injectable } from '@angular/core';

export const emptyTime = '--:--:--';

/**
 * Helper class with functions to manage Date Class
 */
@Injectable({ providedIn: 'root' })
export class DateTimeHelperService {
    readonly MILLISECONDS_IN_DAYS = 86400000;

    /**
     * @returns the time in format 'hh:mm:ss'
     */
    millisecondsToHHMMSS(milliseconds: number | null | undefined): string {
        if (!milliseconds) {
            return emptyTime;
        }
        const oneSecond = 1000;
        const oneMinute = oneSecond * 60;
        const oneHour = oneMinute * 60;

        const seconds = Math.floor((milliseconds % oneMinute) / oneSecond);
        const minutes = Math.floor((milliseconds % oneHour) / oneMinute);
        const hours = Math.floor(milliseconds / oneHour);

        let secondsStr = seconds.toString();
        if (seconds <= 9) {
            secondsStr = '0' + secondsStr;
        }

        let minutesStr = minutes.toString();
        if (minutes <= 9) {
            minutesStr = '0' + minutesStr;
        }

        return `${hours.toString()}:${minutesStr}:${secondsStr}`;
    }

    /**
     * Calculates the days passed between two dates
     * @param initialDate Initial date
     * @param endDate End date
     */
    dateDiffInDays(initialDate: Date, endDate: Date): number {
        const initialDaysOnly = new Date(initialDate.toDateString());
        const endDaysOnly = new Date(endDate.toDateString());

        const initialDays = Math.floor(initialDaysOnly.getTime()) / this.MILLISECONDS_IN_DAYS;
        const endDays = Math.floor(endDaysOnly.getTime() / this.MILLISECONDS_IN_DAYS);

        return endDays - initialDays;
    }

    /**
     * Add a certain quantity of days to the passed date
     * @param date Date to add the days
     * @param days Number of days to add
     */
    addDays(date: Date, days: number): Date {
        const result = new Date(date);
        result.setDate(result.getDate() + days);

        return result;
    }
}
